import { render, staticRenderFns } from "./IDQOL.vue?vue&type=template&id=56b2e0b6&"
import script from "./IDQOL.vue?vue&type=script&lang=js&"
export * from "./IDQOL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports